// Styles for CreateAccountOtpTimer go here.
import styled from 'styled-components';

export const StyledCreateAccountOtpTimer = styled.div``;
